export class CustomError extends Error {
  constructor (message, details) {
    super(message)
    this.details = details
  }

  static createAndThrow (message, details) {
    const error = new this(message, details)
    throw error
  }
}
